module.exports = __webpack_public_path__ + "img/megahobby_sp.1b1e355c.svg";